module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-users-page test-class"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Logs")]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "email-logs",
    attrs: {
      "to": {
        name: 'email-logs'
      }
    }
  }, [_vm._v("Email logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": {
        name: 'consent-logs'
      }
    }
  }, [_vm._v("Consent logs")]), _vm._v(" "), _c('router-link', {
    staticClass: "ttd-logs active",
    attrs: {
      "to": {
        name: 'logs'
      }
    }
  }, [_vm._v("Logs")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [(!_vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-statusbar",
    staticStyle: {
      "margin": "0 15px 20px"
    }
  }, [_c('div', {
    staticClass: "data-list-statusbar__contains data-list-statusbar__block"
  }, [_vm._v(_vm._s(_vm.logsCount) + " logs")])]) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('desktop') && _vm.selectedFilters.length) ? _c('div', {
    staticClass: "data-list-selected-filters"
  }, [_c('div', {
    staticClass: "data-list-selected-filters-applied"
  }, [_c('span', [_vm._v("Filters applied:"), _c('br'), _vm._v(_vm._s(this.logs.length) + " results")])]), _vm._v(" "), _c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "data-list-body"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('thead', {
    attrs: {
      "filters": _vm.getTabletFiltersAppliedText()
    }
  }, [((_vm.getDeviceType('tablet') || _vm.getDeviceType('mobile')) && _vm.selectedFilters.length) ? _c('tr', {
    staticClass: "inside-table-filters"
  }, [_c('th', {
    attrs: {
      "colspan": "9"
    }
  }, [_c('div', {
    staticClass: "data-list-selected-filters-body"
  }, [_vm._l((_vm.selectedFilters), function(filter) {
    return _c('button', {
      class: {
        'hover-filter-element': _vm.isExist(filter)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedFilters(filter)
        },
        "mouseover": function($event) {
          return _vm.addHoverElement([filter])
        },
        "mouseleave": _vm.removeHoverElements
      }
    }, [_c('span', [_vm._v(_vm._s(filter.label))])])
  }), _vm._v(" "), _c('span', {
    staticClass: "data-list-selected-filters-remove-all",
    on: {
      "click": _vm.removeAllFilters,
      "mouseover": function($event) {
        _vm.statusbar.filter.isHover = true
      },
      "mouseleave": function($event) {
        _vm.statusbar.filter.isHover = false
      }
    }
  }, [_vm._v("Clear all filters")])], 2)])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 1,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getUsersForSelect),
        'locked-ceil-head': _vm.userFilterLocked
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(1)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getUsersForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 1
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 1),
      expression: "filerTableHead.selectedCeil === 1"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-1",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getUsersForSelect
    },
    model: {
      value: (_vm.logsUser),
      callback: function($$v) {
        _vm.logsUser = $$v
      },
      expression: "logsUser"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "data-list-search-col text-left column-search-head table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 2,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getEmailsForSelect),
        'locked-ceil-head': _vm.emailFilterLocked
    },
    staticStyle: {
      "width": "194px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(2)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getEmailsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 2
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 2),
      expression: "filerTableHead.selectedCeil === 2"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-2",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getEmailsForSelect
    },
    model: {
      value: (_vm.logsEmail),
      callback: function($$v) {
        _vm.logsEmail = $$v
      },
      expression: "logsEmail"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-role-head table-head-hover table-head-ceil",
    class: {
      'active-ceil-head': _vm.filerTableHead.selectedCeil === 3,
        'hover-head-ceil': _vm.isExistInOptions(_vm.getCompaniesForSelect),
        'locked-ceil-head': _vm.companyFilterLocked
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(3)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getCompaniesForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 3
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 3),
      expression: "filerTableHead.selectedCeil === 3"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-3",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    class: _vm.table - _vm.head - _vm.search,
    attrs: {
      "placeholder": "Search",
      "options": _vm.getCompaniesForSelect
    },
    model: {
      value: (_vm.logsCompany),
      callback: function($$v) {
        _vm.logsCompany = $$v
      },
      expression: "logsCompany"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-status-head table-head-ceil",
    class: {
      'hover-head-ceil': _vm.isExistInOptions(_vm.getActionsForSelect)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideSubMenu(4)
      },
      "mouseover": function($event) {
        return _vm.addHoverElement(_vm.getActionsForSelect)
      },
      "mouseleave": _vm.removeHoverElements
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-icon",
    class: {
      'active': _vm.filerTableHead.selectedCeil === 4
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filerTableHead.selectedCeil === 4),
      expression: "filerTableHead.selectedCeil === 4"
    }],
    staticClass: "wrap-dropdown-table-head",
    attrs: {
      "id": "sub-menu-4",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('app-select', {
    attrs: {
      "placeholder": "Search",
      "options": _vm.getActionsForSelect
    },
    model: {
      value: (_vm.logsAction),
      callback: function($$v) {
        _vm.logsAction = $$v
      },
      expression: "logsAction"
    }
  })], 1)]), _vm._v(" "), _c('th', {
    staticClass: "column-created-head table-head-ceil",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrderBy(true)
      }
    }
  }, [_c('div', {
    staticClass: "caption-head caption-head-order"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-change"
  }, [_c('div', {
    staticClass: "caption-head-order-up",
    class: {
      'active': this.logOrderBy !== null && this.logOrderBy.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption-head-order-down",
    class: {
      'active': this.logOrderBy !== null && !this.logOrderBy.order
    }
  })])])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.logs), function(log, i) {
    return _c('tr', [_c('td', {
      staticClass: "name-cell cellpadding",
      attrs: {
        "data-title": "User:"
      }
    }, [_vm._v(_vm._s(_vm.getUser(log)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Email:"
      }
    }, [_vm._v(_vm._s(_vm.getEmail(log)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell cellpadding",
      attrs: {
        "data-title": "Company:"
      }
    }, [_vm._v(_vm._s(log.companyName ? log.companyName : 'n/a'))]), _vm._v(" "), _c('td', {
      staticClass: "role-cell cellpadding",
      attrs: {
        "data-title": "Action:"
      }
    }, [_vm._v(_vm._s(_vm.getActionName(log)))]), _vm._v(" "), _c('td', {
      staticClass: "created-cell cellpadding text-center",
      attrs: {
        "data-title": "Date and time:"
      }
    }, [_vm._v(_vm._s(_vm.convertDate(log.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "last-login-cell cellpadding text-center",
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "data-title": "Details:"
      }
    }, [_vm._v(_vm._s(log.action ? log.action : 'n/a'))])])
  }), 0)]), _vm._v(" "), (this.logs.length < this.logsCount) ? _c('div', {
    staticClass: "load-more-container"
  }, [_c('div', {
    staticClass: "load-more-btn",
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }, [_vm._m(6), _vm._v("Load more\n        ")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("User")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Action")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Date and time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "column-active-head table-head-ceil"
  }, [_c('div', {
    staticClass: "caption-head"
  }, [_c('div', {
    staticClass: "caption-head-text"
  }, [_c('span', {
    staticClass: "caption-head-inner-text"
  }, [_vm._v("Details")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wave"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e12e77f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Logs.vue
// module id = 990
// module chunks = 0